module.exports = __webpack_public_path__ + "img/35exp.e5a35ef2.jpg";